var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpowerIconInverse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4442_5331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.1 0H5.9C2.64152 0 0 2.64152 0 5.9V74.1C0 77.3585 2.64152 80 5.9 80H74.1C77.3585 80 80 77.3585 80 74.1V5.9C80 2.64152 77.3585 0 74.1 0Z",
    fill: "#202D63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9999 26.7L43.0799 34.5L51.4499 35.02L44.9799 40.36L47.0699 48.49L39.9899 43.99L32.9099 48.49L34.9999 40.36L28.5299 35.02L36.8999 34.5L39.9799 26.7M39.9799 24.95C39.2599 24.95 38.6199 25.3899 38.3499 26.0599L35.6799 32.83L28.4199 33.2799C27.6999 33.3199 27.0899 33.8 26.8599 34.49C26.6399 35.17 26.8599 35.92 27.4099 36.38L33.0199 41.0099L31.1999 48.06C31.0199 48.76 31.2799 49.49 31.8699 49.91C32.1799 50.13 32.5399 50.24 32.8999 50.24C33.2299 50.24 33.5499 50.15 33.8399 49.97L39.9799 46.06L46.1199 49.97C46.4099 50.15 46.7299 50.24 47.0599 50.24C47.4199 50.24 47.7799 50.13 48.0899 49.91C48.6699 49.49 48.9399 48.75 48.7599 48.06L46.9399 41.0099L52.5499 36.38C53.0999 35.92 53.3199 35.17 53.0999 34.49C52.8799 33.81 52.2599 33.3299 51.5399 33.2799L44.2799 32.83L41.6099 26.0599C41.3499 25.3899 40.6999 24.95 39.9799 24.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.82 45.39C60.61 39.99 61.7 33.13 61.7 24.26C51.98 24.26 39.99 13.5 39.99 13.5C39.99 13.5 28 24.26 18.28 24.26C18.28 53.83 30.44 61 39.99 66.5C41.35 65.72 42.77 64.9 44.19 63.99",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.32 54.5801C55.25 53.2401 56.13 51.7501 56.93 50.0901",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.98 61.3101C49.25 60.2901 50.5 59.1601 51.7 57.8601",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4442_5331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpowerIconInverse);
export default __webpack_public_path__ + "static/media/Empower-Icon-Inverse.cd0faf6b168ab74606f82940af04a05e.svg";
export { ForwardRef as ReactComponent };